module.exports = __webpack_public_path__ + "dingbeauty/admin/img/staff_avatar_haku.d71bfdb4.png";